import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import { BannerDetails_banner_brand } from "@saleor/banners/types/BannerDetails";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableHead from "@saleor/components/TableHead";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
export interface BannerBrandsProps {
  brand: BannerDetails_banner_brand;
  onBrandAssign?: () => void;
  onBrandUnassign?: (id: string) => void;
  disabled?: boolean;
  onRowClick: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 230
    },
    colNameLabel: {},
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 150
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "BannerBrands" }
);

const numberOfColumnsVoucher = 3;

const BannerBrands: React.FC<BannerBrandsProps> = props => {
  const {
    brand,
    onBrandAssign,
    onBrandUnassign,
    disabled
    // onRowClick
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  function showProductTable() {
    const brandData = brand ? [brand] : [];

    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumnsVoucher}
          disabled={false}
          hideCheckBox
          items={[brand]}
          toolbar={toolbar}
        >
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Brand" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Company" />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <TableBody>
          {renderCollection(
            brandData,
            brand => (
              <TableRow
                hover={!!brand}
                key={brand ? brand.id : "skeleton"}
                className={classes.tableRow}
              >
                <TableCell className={classes.colName}>
                  {maybe<React.ReactNode>(() => brand.name, <Skeleton />)}
                </TableCell>
                <TableCell className={classes.colType}>
                  {maybe<React.ReactNode>(() => brand.legalName, <Skeleton />)}
                </TableCell>
                <TableCell className={classes.colActions}>
                  <IconButton
                    disabled={!brand}
                    onClick={event => {
                      event.stopPropagation();
                      onBrandUnassign(brand.id);
                    }}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumnsVoucher}>
                  <FormattedMessage defaultMessage="Click Assign Brand to add a featured brand in this list" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Featured Brand",
          description: "section header"
        })}
        toolbar={
          <Button
            id="assignBrandBtn"
            disabled={!!brand || disabled}
            color="primary"
            className={!!brand || disabled ? classes.buttonDisabled : null}
            onClick={onBrandAssign}
          >
            <FormattedMessage
              defaultMessage="Assign brand"
              description="button"
            />
          </Button>
        }
      />
      {showProductTable()}
    </Card>
  );
};
BannerBrands.displayName = "BannerBrands";
export default BannerBrands;
